

jQuery(document).ready(function(){

    jQuery('.menu-toggle-button').click(function() {
        jQuery('.header-navigation').toggleClass('opened');
        jQuery(this).toggleClass('active');
        return false;
    });
    jQuery(".header-navigation li.menu-item-has-children > a").click(function() {
        jQuery(this).parent().toggleClass('opened');
        return false;
    });
    jQuery(document).click(function() {
        // Закрываем всё
        jQuery('.header-navigation').removeClass('opened');
        jQuery('.header-navigation li.menu-item-has-children').removeClass('opened');
        jQuery('.menu-toggle-button').removeClass('active');
    });
    jQuery(window).resize(function() {
        jQuery('.header-navigation').removeClass('opened');
        jQuery('.header-navigation li.menu-item-has-children').removeClass('opened');
        jQuery('.menu-toggle-button').removeClass('active');
    });




    jQuery('.reviews-slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        /*responsive: [
            {
                breakpoint: 1024,
                settings: {
                    //adaptiveHeight: true
                }
            }
        ]*/
    });


    jQuery('.services-slider').owlCarousel({
        loop: true,
        nav: true,
        margin: 20,
        smartSpeed: 700,
        navText: ['',''],

        responsive:{
            0:{
                items: 1
            },
            490:{
                items: 2
            },
            760:{
                items: 3
            },
        }
    });

    jQuery('.products-slider').owlCarousel({
        loop: true,
        nav: true,
        margin: 10,
        smartSpeed: 700,
        navText: ['',''],

        responsive:{
            0:{
                items: 2
            },
            490:{
                margin: 20,
                items: 4
            },
            760:{
                items: 5
            },
        }
    });



    ////////////////////////////////////
    // Find all YouTube videos
    var $allVideos = jQuery("iframe[src^='https://www.youtube.com']");

    // Figure out and save aspect ratio for each video
    $allVideos.each(function() {
        $(this)
            .attr('data-aspectRatio', this.height / this.width)
            .removeAttr('height')
            .removeAttr('width');

    });

    jQuery(window).resize(function() {
        // Resize all videos according to their own aspect ratio
        $allVideos.each(function() {

            var $el = jQuery(this);
            $el.height( $el.width() * $el.attr('data-aspectRatio'));
            $el.attr('height', $el.width() * $el.attr('data-aspectRatio'))
        });
    }).resize();
    ////////////////////////////////////



    jQuery('.open-modal').magnificPopup({
        type:'inline',
        midClick: true
        //alignTop: true
        //overflowY: 'scroll'
    });



    jQuery('.news-list_more-link').click(function () {
        jQuery(".news-list_item:hidden").slice(0, 6).slideDown();
        if (jQuery(".news-list_item:hidden").length == 0) {
            jQuery(".news-list_more").hide();
        }

        return false;
    });
    jQuery('.news-list_more-link').click();
    if (jQuery(".news-list_item:hidden").length > 0) {
        jQuery(".news-list_more").show();
    }

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        if ( '5' == event.detail.contactFormId ) {
            jQuery('form.wpcf7form').trigger('reset');
            jQuery('#feedback_form').hide();
            jQuery('#feedback_form_sended').show();
        }
        if ( '278' == event.detail.contactFormId ) {
            jQuery('form.wpcf7form').trigger('reset');
            jQuery('#mainForm').hide();
            jQuery('#mainForm_sended').show();
        }
    }, false );


    if (jQuery('.table-wrapper').length > 0) {
        var ps = new PerfectScrollbar('.table-wrapper', {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20
        });
    }


    jQuery('#modal-form_phone').inputmask({"mask": "+7 (999) 999-99-99"});
    jQuery('#contacts-form_phone').inputmask({"mask": "+7 (999) 999-99-99"});

});
